/*================ Shopify Common JS ================*/
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  } 
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  if (this.countryEl) {
    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

    this.initCountry();
    this.initProvince();
  }
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

Shopify.formatMoney = function(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

/*================ Helper Functions ================*/
// HEADROOM
const header = document.querySelector(".headroom");
const headroom  = new Headroom(header);
headroom.init();


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

function setCookie(name, value, days) {
  var d = new Date;
  d.setTime(d.getTime() + 24*60*60*1000*days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

function slideUp(target, duration = 500) {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout( () => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        //alert("!");
  }, duration);
}

function slideDown(target, duration = 500) {
  target.style.removeProperty('display');
  let display = window.getComputedStyle(target).display;
  if (display === 'none') display = 'block';
  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + 'ms';
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout( () => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
}

function slideToggle(target, duration = 500) {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
}

function fadeIn(target, duration = 500) {
  target.style.display = '';
  target.style.opacity = 0;
  var last = +new Date();
  var tick = function() {
    target.style.opacity = +target.style.opacity + (new Date() - last) / duration;
    last = +new Date();
    if (+target.style.opacity < 1) {
      (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
    }
  };
  tick();
}

function fadeOut(target, duration = 500) {
  target.style.display = '';
  target.style.opacity = 1;
  let last = +new Date();
  let tick = function() {
    target.style.opacity = Number(+target.style.opacity - (new Date() - last) / duration).toFixed(4);
    last = +new Date();
    if (-target.style.opacity <= 0) {
      (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
    } else{
        target.style.opacity = 0;
    }
  };
  tick();
}

function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
}

function atcGetSectionsToRender() {
  return [
    {
      id: ['cart-drawer__content', 'cart-drawer__footer'],
      section: document.getElementById('cart-drawer__content').dataset.id,
    },
    {
      id: ['cart-icon-bubble', 'cart-drawer-count', 'cart-subtotal-count'],
      section: 'cart-icon-bubble'
    }
  ];
}

function addToCart(body, openCart = true, button, additionalSectionsToRender = []) {

  fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
  .then((response) => response.json())
  .then((parsedState) => {
    atcGetSectionsToRender().forEach((section => {
      if(typeof section.id == 'string'){
        const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        
        elementToReplace.innerHTML =
        getSectionInnerHTML(parsedState.sections[section.section], section.selector || `#${section.id}`);
      } else {
        section.id.forEach(id => {
          const elementToReplace = document.getElementById(id).querySelector(section.selector) || document.getElementById(id);

          const newInnerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector || `#${id}` )

          elementToReplace.innerHTML = newInnerHTML
        })
      }
    }));

    if(additionalSectionsToRender.length > 0){
      additionalSectionsToRender.forEach((section => {
        if(typeof section.id == 'string'){
          if(section.id == 'product-form') {
            const elementToReplace = section.selector ? document.getElementById(`product-form__submit--${section.selector}`) : document.getElementById(`product-form__submit--${section.section}`)

            elementToReplace.innerHTML = section.selector ? getSectionInnerHTML( parsedState.sections[section.section], `#product-form__submit--${section.selector}`) : getSectionInnerHTML( parsedState.sections[section.section], `#product-form__submit--${section.section}`)

          } else {
            const elementToReplace = document.getElementById(section.id) ? document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id) : document.getElementById(`shopify-section-${section.id}`).querySelector(section.selector) || document.getElementById(section.id);
          
            elementToReplace.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector || `#${section.id}`)

            if(section.id == "bundle-builder") {
              elementToReplace._reset()
            }
          }
        } else {
          section.id.forEach(id => {
            const elementToReplace = document.getElementById(id).querySelector(section.selector) || document.getElementById(id);

            const newInnerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector || `#${id}` )

            elementToReplace.innerHTML = newInnerHTML
          })
        }
      }));
    }
    
  })
  .catch((e) => {
    console.error(e);
  })
  .finally(() => {
    if (openCart) {
      document.querySelector('cart-drawer').initUpsells()
      document.querySelector('cart-drawer').open();

      if(button) {
        button.classList.remove('loading');
        button.removeAttribute('disabled');
      }
    }
  });
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

/*================ Initialize ================*/
// Micromodal
MicroModal.init({
  onShow: modal => console.info(`${modal.id} is shown`), // [1]
  onClose: modal => {console.info(`${modal.id} is hidden`); modal.classList.remove('is-open')},
  disableScroll: true,
  disableFocus: true,
  awaitOpenAnimation: true,
  awaitCloseAnimation: true
});

/*================ Components ================*/
var MenuDrawer = class extends HTMLElement {
  constructor() {
    super();

    this.drawer = this.drawer = document.getElementById('menu-drawer');
    this.openButtons = document.querySelectorAll('.js-open-menu');
    this.closeButtons = document.querySelectorAll('.js-close-menu');
    this.menuButtons = document.querySelectorAll('.menu-drawer__menu-button');
    this.pageOverlayElement = document.querySelector('.page-overlay');
    
    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeMenuDrawer());
    this.bindEvents();
  }

  bindEvents() {
    this.openButtons.forEach(openBtn => openBtn.addEventListener('click', this.openMenuDrawer.bind(this)));
    this.closeButtons.forEach(closeBtn => closeBtn.addEventListener('click', this.closeMenuDrawer.bind(this)));
    this.menuButtons.forEach(menuBtn => menuBtn.addEventListener('click', this.toggleMenuButtons.bind(this)));
    this.onBodyClick = this.handleBodyClick.bind(this);
  }

  openMenuDrawer() {
    this.drawer.setAttribute('aria-hidden', false);
    this.drawer.setAttribute('aria-expanded', true);

    this.pageOverlayElement.classList.add('is-visible');
    document.body.addEventListener('click', this.onBodyClick);
  }

  closeMenuDrawer() {
    this.drawer.setAttribute('aria-hidden', true);
    this.drawer.removeAttribute('aria-expanded', true);

    this.pageOverlayElement.classList.remove('is-visible');
    document.body.removeEventListener('click', this.onBodyClick);
  }

  toggleMenuButtons() {
    const parent = event.target.parentElement;
    const secondaryMenu = event.target.nextElementSibling;
    
    if (parent.classList.contains('is-open')) {
      slideUp(secondaryMenu);
      parent.classList.remove('is-open');
    } else {
      slideDown(secondaryMenu);
      parent.classList.add('is-open');
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target.classList.contains('page-overlay')) {
      this.closeMenuDrawer();
      this.pageOverlayElement.classList.remove('is-visible');
    }
  }
}

customElements.define('menu-drawer', MenuDrawer);

customElements.define('product-form', class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartDrawer = document.querySelector('cart-drawer');
  }

  onSubmitHandler(evt) {
    evt?.preventDefault();
    
    const submitButton = this.querySelector('[type="submit"]');

    if(submitButton) {
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');
    }

    // const body = JSON.stringify({
    //   ...JSON.parse(serializeForm(this.form)),
    //   sections: this.getSectionsToRender().map((section) => section.section),
    //   sections_url: window.location.pathname
    // });

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    formData.append(
        'sections',
        this.getSectionsToRender().map((section) => section.section),
      );
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((parsedState) => {

        this.getSectionsToRender().forEach((section => {
          if(typeof section.id == 'string'){
            const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            
            elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          } else {
            section.id.forEach(id => {
              const elementToReplace = document.getElementById(id).querySelector(section.selector) || document.getElementById(id);

              const newInnerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector || `#${id}` )

              elementToReplace.innerHTML = newInnerHTML
            })
          }

        }));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        this.cartDrawer.initUpsells()
        this.cartDrawer.open();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: ['cart-drawer__content', 'cart-drawer__footer'],
        section: document.getElementById('cart-drawer__content').dataset.id
      },
      {
        id: ['cart-icon-bubble', 'cart-drawer-count', 'cart-subtotal-count'],
        section: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
});

var QuantityInput = class extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

var BundleBuilder = class extends HTMLElement {
  static get observedAttributes() {
    return ['active-variant'];
  }

  constructor() {
    super()

    this.products = this.querySelectorAll('product-card')
    this.total = 0
    this.priceWrapper = this.querySelector("[data-bundle-price]")
    this.isKit = this.getAttribute("active-variant") == 'kit' ? true : false
    this.kitAvailable = true
    this.addBundle = this.querySelector('[data-add-to-cart]')
    this.discountPercentage = null
  }

  connectedCallback() {
    if(this.getAttribute("active-variant") != 'null' ){
      this._updateProducts(this.getAttribute("active-variant"))
    }

    this._setPrice();

    this.addBundle.addEventListener('click', this._addToCart.bind(this))

    if(this.isKit) {
      this.discountPercentage = (parseFloat(this.dataset.price) / parseFloat(this.dataset.compareAt)).toFixed(4)
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue !== oldValue) {
      if(name == 'active-variant' && newValue != 'null' && oldValue != 'null' ){
        const newVariant = this.getAttribute('active-variant')
        this._updateProducts(newVariant)
      }
    }
  }

  _reset() {
    this.products = this.querySelectorAll('product-card')
    this.total = 0
    this.priceWrapper = this.querySelector("[data-bundle-price]")
    this.isKit = this.getAttribute("active-variant") == 'kit' ? true : false
    this.kitAvailable = true
    this.addBundle = this.querySelector('[data-add-to-cart]')

    if(this.getAttribute("active-variant") != 'null' ){
      this._updateProducts(this.getAttribute("active-variant"))
    }

    this._setPrice();

    this.addBundle.addEventListener('click', this._addToCart.bind(this))
  }

  _toggleButton(disable = true, text, modifyClass = true) {
    if(disable) {
      this.addBundle.setAttribute('disabled', 'disabled')
      this.addBundle.nextElementSibling.style.display = 'block'
    } else {
      this.addBundle.removeAttribute('disabled')
      this.addBundle.nextElementSibling.style.display = 'none'
    }
  }

  _updateProducts(_v){
    this.products.forEach( (_p) => {
      if(!this.isKit) {
        if(_p.querySelector(`input[type='radio'][value='${_v}']:not(.disabled)`)) {
          _p.querySelector(`input[type='radio'][value='${_v}']`).click()
        }
      }
    })
  }

  _setPrice(){
    this.kitAvailable = true

    this.total = 0
    this.products.forEach( (_p) => {
      // is product checked?
      const includeProduct = _p.nextElementSibling.dataset.active
      const _variantRadios = _p.querySelector("variant-radios")
      
      if(includeProduct) {
        this.total = this.total + parseInt(_variantRadios.dataset.price)
      } else {
        this.kitAvailable = false
      }
      
    })

    if(this.discountPercentage != null) {
      this.querySelector('[data-bundle-compare-price').textContent = (this.total * .01).toFixed(2)
      this.querySelector('[data-bundle-compare-price').classList.remove("hidden")
      this.priceWrapper.textContent = (this.total * .01 * this.discountPercentage).toFixed(2)
    } else {
      this.priceWrapper.textContent = (this.total * .01).toFixed(2)
      if (this.querySelector('[data-bundle-compare-price')) {
        this.querySelector('[data-bundle-compare-price').classList.add("hidden")
        this.querySelector('[data-bundle-compare-price').textContent = "";
      } 
      
    }
    

    if(this.isKit){
      this._toggleButton(!this.kitAvailable)
    }
  }

  _addToCart() {
    const items = []

    this.products.forEach( (_p) => {
      // is product checked?
      const includeProduct = _p.nextElementSibling.dataset.active
      const _variantId = _p.querySelector("product-form input[name='id']").value
      
      if(includeProduct) {
        items.push({ id: _variantId, quantity: 1})
      }
      
    })

    const body = JSON.stringify({
      items: [...items],
      sections: atcGetSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    })

    addToCart(body);
  }
}
customElements.define('bundle-builder', BundleBuilder)

var VariantSelects = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.container = this.dataset.container == 'main-product' || this.dataset.container == 'feature-product' ? this.closest(`#shopify-section-${this.dataset.sectionId}`) : this.closest(`product-card`)
    this.isGiftcard = this.getAttribute('data-is-giftcard') ? true : false

    this.hiddenVariants = this.getHiddenVariants().filter( v => {
      if (v.hide == true) {
        return v.id
      }
    }).map( v => v.id)

    this.hiddenFromStore = this.getHiddenFromStore().filter( v => {
      if (v.hide == true) {
        return v.id
      }
    }).map( v => v.id)

    this.memberExclusive = this.getMemberExclusives().filter( v => {
      if (v.exclusive == true) {
        return v.id
      }
    }).map( v => v.id)

    this.stickyATC = document.querySelector(`sticky-atc[data-form-id="${this.dataset.productId}-${ this.dataset.sectionId}"]`)
  }

  connectedCallback() {  
    this.updateOptions()
    this.updateMasterId()
    this.updateVariantStatuses()

    const triggerNewChange = this.checkVariantOptions(true)
    this.dispatchEvent(new Event("change"))    
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId(event.target.value);

    this.updateLabel(event.target)
    // this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    this.updateVariantStatuses();
    // before doing anything else, make sure the selected variant options are available
    // if not, select the first available option instead
    const triggerNewChange = this.checkVariantOptions()
    if(triggerNewChange) {
      this.dispatchEvent(new Event("change"))
    }
    
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      if (!this.isGiftcard) {
        this.setAttribute('data-price', this.currentVariant.price)
        this.setAttribute('data-available', (this.currentVariant.available))
        this.updateContainer();

        if(this.dataset.container == 'main-product' || this.dataset.container == 'feature-product') {
          this.updateMedia();
          this.passVariantColor()
        }
        this.updateBundle()
      }

      if(this.dataset.container == 'main-product' || this.dataset.container == 'feature-product') {
        this.renderProductInfo();   
      } else if (this.dataset.container == 'product-details'){
        this.renderProductDetailsContent()
      } else {
        this.renderProductCardInfo()
      }

      this.updateURL();
      this.updateVariantInput();
      this.updateShareUrl();
    }
  }

  passVariantColor(){
    if (this.dataset.container == 'feature-product') return;
    const color_option_position = this.dataset.colorPosition
    const bundleBuilder = document.querySelector('bundle-builder')

    if(bundleBuilder) {
      bundleBuilder.setAttribute('active-variant', this.currentVariant.options[color_option_position - 1])
    }
  }

  updateBundle() {
    const _bundle = this.closest('bundle-builder')
    if(_bundle) {
      _bundle._setPrice()
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  checkVariantOptions(x) {
  }

  updateLabel(el) {
    if(el.tagName == "INPUT") {
      const parent = el.closest("[data-option-wrapper]")
      if(!parent) return

      const labelElement = parent.querySelector("[data-option-label]")
      if (!labelElement) return
      labelElement.innerText = el.value

    } else if (el.tagName == 'VARIANT-RADIOS') {
      el.querySelectorAll("[data-option-wrapper]").forEach( wrapper => {
        const labelElement = wrapper.querySelector("[data-option-label]")
        if (!labelElement) return
        labelElement.innerText = wrapper.querySelector("input:checked").value
      })
    }
  }

  updateMasterId(selection) {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateContainer(){
    const primaryColor = this.querySelector("[data-fieldset][data-type='color'] input:checked") ? this.querySelector("[data-fieldset][data-type='color'] input:checked").dataset.primaryColor : "#e5e7e9"
    const secondaryColor = this.querySelector("[data-fieldset][data-type='color'] input:checked") ? this.querySelector("[data-fieldset][data-type='color'] input:checked").dataset.secondaryColor : "#fff"

    if(this.dataset.container == 'product-card') {
      const productCard = this.closest("product-card")
      productCard.setAttribute("active-variant", JSON.stringify(this.currentVariant))
      productCard.style = `--primary-color: ${ primaryColor }; --secondary-color: ${ secondaryColor};`

      if(productCard.hasAttribute("data-quick-add-container")){
        productCard.querySelector("quick-add")?.classList.toggle("hidden", !this.currentVariant.available)
      }

      const bundleButton = productCard.nextElementSibling

      if (bundleButton == null ) return

      if(bundleButton.tagName == 'BUNDLE-BUTTON'){
        if(this.memberExclusive.includes(this.currentVariant.id)){
          if(bundleButton.getAttribute('data-active') == "true") {
            bundleButton.click()
            bundleButton.classList.toggle('disabled', true)
          }
        } else if ( bundleButton.getAttribute("data-active") && !this.currentVariant.available) {
          bundleButton.click()
          bundleButton.classList.toggle('disabled', !this.currentVariant.available)
        } else if (bundleButton.getAttribute("data-active") == null && this.currentVariant.available) {
          bundleButton.click()
          bundleButton.classList.toggle('disabled', !this.currentVariant.available)
        }
      }
    }

    if(this.dataset.container == 'main-product'){
      document.body.style = `--primary-color: ${ primaryColor }; --secondary-color: ${ secondaryColor};`
    }

    if(this.dataset.container == 'feature-product'){
      this.container.querySelector("section").style = `--primary-color: ${ primaryColor }; --secondary-color: ${ secondaryColor};`
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    
    this.container.querySelector("[data-product-zoom-index='0'] img").src =  this.currentVariant.featured_media?.src || this.currentVariant.featured_image?.src
      this.container.querySelector("[data-product-zoom-index='0'] img").alt =  this.currentVariant.featured_media?.alt || this.currentVariant.featured_image?.alt
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;

    let fetchUrl = new URL(`${this.dataset.url}`, window.location);
    let fetchParams = new URLSearchParams(window.location.search)
    // let fetchParams = new URLSearchParams(fetchUrl.search);

    if(fetchParams.has('variant') && fetchParams.get('variant') != this.currentVariant.id ){
      fetchParams.set('variant',`${this.currentVariant.id}`)
    } else if(!fetchParams.has('variant')) {
      fetchParams.append('variant', `${this.currentVariant.id}`);
    }

    if (this.container.tagName == 'PRODUCT-CARD') {
      this.container.firstElementChild.href = `${this.dataset.url}?variant=${this.currentVariant.id}`
    } else if( this.dataset.container == 'main-product') {
      window.history.replaceState({ }, '', `${fetchUrl.href}${fetchUrl.search == '' ? '?' : ''}${fetchParams.toString()}`)
    }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    )

    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    let stickyInputWrappers = []
    if(this.stickyATC){
      stickyInputWrappers = [...this.stickyATC.querySelectorAll('.product-form__input')];
     }
    inputWrappers.forEach((option, index) => {
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      if (index === 0) {
        const availableOptionInputsValue = this.variantData.filter((variant) => !this.hiddenFromStore.includes(variant.id)).filter((variant) =>  variant.available || !variant.available && !this.hiddenVariants.includes(variant.id)).map((variantOption) => variantOption[`option1`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue);
        
        if(this.stickyATC){ 
          this.setStickyAvailability(stickyInputWrappers[index], availableOptionInputsValue, this.currentVariant ? this.currentVariant[`option${index + 1}`] : '')
        }
      } else {
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;

        const availableOptionInputsValue = selectedOptionOneVariants
          .filter((variant) => !this.hiddenFromStore.includes(variant.id))
          .filter((variant) =>  variant.available || !variant.available && !this.hiddenVariants.includes(variant.id))
          .filter((variant) => variant[`option${index}`] === previousOptionSelected)
          .map((variantOption) => variantOption[`option${index + 1}`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue);
        
        if(this.stickyATC){ 
          this.setStickyAvailability(stickyInputWrappers[index],availableOptionInputsValue, this.currentVariant ? this.currentVariant[`option${index + 1}`] : "")
        }
      }
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  setStickyAvailability() {

  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductDetailsContent() {
    const fetchLink = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=product-details-content`

    const sectionsToRender = [
      {
        id: 'product-details-content',
        selector: '.product-description',
      },
      {
        id: 'product-details-swiper',
        selector: '.swiper-wrapper'
      }
    ]

    fetch(fetchLink)
      .then((response) => response.text())
      .then((state) => {
        const html = new DOMParser()
              .parseFromString(state, 'text/html')

        sectionsToRender.forEach(section => {
          const elementToReplace =
            document.getElementById(`${section.id}`)

            if (elementToReplace == undefined || elementToReplace == null) return

            if(section.selector == ''){
              elementToReplace.innerHTML = html.querySelector(`#${section.id}`).innerHTML
            } else {
              elementToReplace.querySelector(section.selector).innerHTML =
              html.querySelector(`#${section.id} ${section.selector}`).innerHTML;
            }
        })
        
      })
  }

  renderProductCardInfo() {
    const fetchLink = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=product-card-info`

    fetch(fetchLink)
      .then((response) => response.text())
      .then((state) => {
        const html = new DOMParser()
              .parseFromString(state, 'text/html')

        const priceToReplace =
            document.getElementById(`product-card-price-${this.dataset.section}`)

        priceToReplace.innerHTML = html.querySelector(`#product-card-price-${this.dataset.productId}`).innerHTML

        const flagsToReplace =
            document.getElementById(`product-card-flags-${this.dataset.section}`)

        flagsToReplace.innerHTML = html.querySelector(`#product-card-flags-${this.dataset.productId}`).innerHTML

        const cardButton =
            document.getElementById(`product-card__button-wrapper-${this.dataset.section}`)

            if(cardButton && cardButton.dataset.bundle != 'true') {
              cardButton.innerHTML = html.querySelector(`#product-card__button-wrapper-${this.dataset.productId}`).innerHTML
            }
      })
  }

  renderProductInfo() {
    // const fetchLink = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.sectionId}`
    let fetchUrl = new URL(`${this.dataset.url}`, window.location);
    let fetchParams = new URLSearchParams(window.location.search)
    // let fetchParams = new URLSearchParams(fetchUrl.search);

    if(fetchParams.has('variant') && fetchParams.get('variant') != this.currentVariant.id ){
      fetchParams.set('variant',`${this.currentVariant.id}`)
    } else if(!fetchParams.has('variant')) {
      fetchParams.append('variant', `${this.currentVariant.id}`);
    }

    // fetchParams.append('section_id', `${this.dataset.sectionId}`);
    if(fetchParams.has('section_id') && fetchParams.get('section_id') != this.dataset.sectionId ){
      fetchParams.set('section_id',`${this.dataset.sectionId}`)
    } else if(!fetchParams.has('section_id')) {
      fetchParams.append('section_id', `${this.dataset.sectionId}`);
    }
    

    fetch(`${fetchUrl.href}${fetchUrl.search == '' ? '?' : ''}${fetchParams.toString()}`)
      .then((response) => response.text())
      .then((state) => {
        // const parsedState = JSON.parse(state);
        const html = new DOMParser()
              .parseFromString(state, 'text/html')

        // Replace sections
        this.getSectionsToRender().forEach((section => {
          if(section.id == 'product-form') {
            const elementToReplace =
            document.getElementById(`product-form__submit--${this.dataset.section}`)

            elementToReplace.innerHTML = html.querySelector(`#product-form__submit--${this.dataset.section}`).innerHTML

            if(this.hiddenFromStore.includes(this.currentVariant.id)) {
              this.toggleAddButton(true, 'Unavailable');
            } else {
              this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
            }

          } else {
            const elementToReplace =
            document.getElementById(`${section.id}-${this.dataset.section}`)

            if (elementToReplace == undefined || elementToReplace == null) return

            if(section.selector == ''){
              elementToReplace.innerHTML = html.querySelector(`#${section.id}-${this.dataset.section}`).innerHTML
            } else {
              elementToReplace.querySelector(section.selector).innerHTML =
              html.querySelector(`#${section.id}-${this.dataset.section} ${section.selector}`).innerHTML;
            }

            // if(section.id == 'price' && this.stickyATC) {
            //   this.stickyATC.querySelector("#sticky-price").innerHTML = html.querySelector(`#${section.id}-${this.dataset.section}`).innerHTML
            // }
          }
        }));
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'product-form',
        selector: '#product-form-wrapper',
      },
      {
        id: `price`,
        selector: '',
      },
      {
        id: 'product-description',
        selector: ''
      },
      {
        id: 'product-media',
        selector: ''
      },
      {
        id: 'product-zoom-modal',
        selector: '.swiper-wrapper'
      }
    ];
  }

  getSectionInnerHTML(html, selector){
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  toggleAddButton(disable = true, text = "Out of Stock", modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;

    productForm.querySelector(".product-form__buttons").classList.toggle("product-form__buttons-unavailable", disable)
    
    productForm.querySelector(".product-form__quantity").classList.toggle('hidden', disable)

    if(this.stickyATC) {
      this.stickyATC.querySelector(".product-form__buttons").classList.toggle('product-form__buttons-unavailable', disable)
    }
  
    const addButton = productForm.querySelector('[name="add"]')
    
    if (addButton) {
      const addButtonText = addButton.querySelector("span:first-of-type")
      const addButtonPrice = addButtonText.nextElementSibling

      addButton.toggleAttribute('disabled', disable);
      addButtonText.textContent = disable ? text : window.variantStrings.addToCart;
      addButtonPrice.classList.toggle(disable)
    }

    if(this.stickyATC) {
      if(addButton) {
        this.stickyATC.querySelector('[name="add"]').toggleAttribute('disabled', disable)
        this.stickyATC.querySelector('[name="add"] span:first-of-type').textContent = disable ? text : window.variantStrings.addToCart;
        this.stickyATC.querySelector('[name="add"] span:first-of-type').nextElementSibling.classList.toggle( disable)
      } else {
        this.stickyATC.querySelector('[name="add"]').toggleAttribute('disabled', false)
        this.stickyATC.querySelector('[name="add"] span:first-of-type').textContent = "Become a Member to Purchase"
        this.stickyATC.querySelector('[name="add"] span:first-of-type').nextElementSibling.classList.toggle('hidden', true)
      }
      
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const form = document.getElementById(`product-form-${this.dataset.section}`);
    
    const addButton = form.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector("span:first-child")
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price){
      price.classList.add('visibility-hidden');
    } 

    if(this.stickyATC) {
      this.stickyATC.querySelector('[name="add"] span:first-of-type').textContent = window.variantStrings.unavailable;
      this.stickyATC.querySelector('[name="add"] span:first-of-type').nextElementSibling.classList.add('visibility-hidden')
    }

  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getHiddenVariants() {
    if (this.querySelector('#hidden-variants')) {
      return JSON.parse(this.querySelector('#hidden-variants').textContent);
    } 
  }

  getHiddenFromStore() {
    if (this.querySelector('#hidden-from-store')) {
      return JSON.parse(this.querySelector('#hidden-from-store').textContent);
    } 
  }

  getMemberExclusives() {
    if (this.querySelector('#member-exclusives')) {
      return JSON.parse(this.querySelector('#member-exclusives').textContent);
    } 
  }
}

customElements.define('variant-selects', VariantSelects);

var VariantRadios = class extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.closest('label').classList.remove('disabled');
        input.classList.remove('disabled');
        input.removeAttribute("data-hidden")
      } else {
        input.closest('label').classList.add('disabled');
        input.classList.add('disabled');
        input.setAttribute("data-hidden", true)
      }
    });
  }

  setStickyAvailability(listOfOptions, listOfAvailableOptions, selectedOption) {
    listOfOptions.querySelectorAll("button[data-value]").forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('data-value'))) {
        input.parentElement.classList.remove('disabled');
        input.classList.remove('disabled');
        input.removeAttribute("data-hidden")
      } else {
        input.parentElement.classList.add('disabled');
        input.classList.add('disabled');
        input.setAttribute("data-hidden", true)
      }

      if(input.dataset.value == selectedOption) {
        input.classList.add('selected')
      } else {
        input.classList.remove('selected')
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('[data-fieldset]'));

    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  checkVariantOptions(x) {
    let triggerNewChange = false
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((input, index) => {
      if(index === 0 && x != true ) return;
      if (input.querySelector(":checked").hasAttribute("data-hidden")) {
        if (input.querySelector("input:not([data-hidden])") ) {
          input.querySelector("input:not([data-hidden])").checked = true
          triggerNewChange = true
          return
        }
      }
    })

    return triggerNewChange
  }
}

customElements.define('variant-radios', VariantRadios);

var AddToCart = class extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    event.preventDefault();
    const id = this.dataset.id;

    const body = JSON.stringify({
      items: [{
        id: id,
        quantity: 1
      }],
      sections: atcGetSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    addToCart(body);
  }
}

customElements.define('add-to-cart', AddToCart);

const heroSliders = document.querySelectorAll('.section-hero-slider')

if (heroSliders) {
  let _r = document.querySelector(':root');
  heroSliders.forEach((hero) => {

    let topHero = false
    let shopifySection = hero.closest(".shopify-section")
    let parent = shopifySection.parentNode

    if ( parent.tagName == 'MAIN' && shopifySection == parent.firstElementChild ){
      topHero = true
    }

    if(topHero) {
      _r.style.setProperty('--headerTextColor', hero.querySelector(".swiper-slide:first-child").dataset.navColor);
    }
    
    hero.style.color = hero.querySelector(".swiper-slide:first-child").dataset.navColor

    const swiper = new Swiper(hero, {
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
        return `<span class="swiper-pagination-bullet">${index}</span>`;
        },
      }
    })
    
    swiper.on('slideChange', function () {
      const color = swiper.slides[swiper.activeIndex].dataset.navColor
      hero.style.color = color
      if(topHero) {
        _r.style.setProperty('--headerTextColor', color);
      }
      
    });
  })
}



const featuredProductsSlider = document.querySelectorAll('.featured-product-swiper')

featuredProductsSlider.forEach(feature => {
  const swiper = new Swiper(feature, {
    slidesPerView: 1.2,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: 
      {
        768: {
          slidesPerView: 4.5
        }
      }
  })
})

const $balaStarsSliders = document.querySelectorAll('.js-bala-stars')
const $currentSlidePagination = document.querySelector('.js-stars-current-idx');
$balaStarsSliders.forEach(star => {
  const swiper = new Swiper(star, {
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: '.stars-swiper-button-next',
      prevEl: '.stars-swiper-button-prev',
    },
  })

  $currentSlidePagination.textContent = `${swiper.activeIndex + 1 < 10 ? '0' : ''}${swiper.activeIndex + 1}`;

  swiper.on('slideChange', function () {
    const $currentSlidePagination = document.querySelector('.js-stars-current-idx');
    $currentSlidePagination.textContent = `${swiper.activeIndex + 1 < 10 ? '0' : ''}${swiper.activeIndex + 1}`;
  });
})

const $instructorsSliders = document.querySelectorAll('.js-instructors-swiper')
$instructorsSliders.forEach(instructor => {
  const swiper = new Swiper(instructor, {
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: '.instructor-swiper-button-next',
      prevEl: '.instructor-swiper-button-prev',
    },
    pagination: {
      el: '.instructor-swiper-pagination',
      clickable: true,
      renderBullet: function (index) {
        return `<span class="swiper-pagination-bullet">${index + 1}</span>`;
      }
    }
  })
})


customElements.define('quick-add', class QuickAdd extends HTMLElement {
  constructor() {
    super();

    this.container = this.closest("[data-quick-add-container]")
    this.productForm = this.container.querySelector("product-form")

    this.addEventListener('click', this.handleClick.bind(this))
  }

  handleClick(event) {
    event.preventDefault()
    this.productForm.onSubmitHandler()
  }
})

customElements.define('product-card', class ProductCard extends HTMLElement {
  static get observedAttributes() {
    return ['active-variant'];
  }

  get activeVariant() {
    return this.getAttribute('active-variant')
  }
  set activeVariant(v) {
    if(v){
      this.setAttribute('active-variant', v)
    }
  }

  constructor() {
    super();
    this.allImages = JSON.parse(this.querySelector('[data-product-images]').textContent)
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue != null && newValue !== oldValue) {
      if(name == 'active-variant'){
        const newVariant = JSON.parse(this.getAttribute('active-variant'))
        this._updateImages(newVariant)
      }
    }
  }

  _updateImages(v){
    const variantImages = this.allImages.filter(img => img.alt == v.featured_media.alt)

    if( v.featuredImage == null && variantImages.length == 0 ) return

    const firstImage = v.featuredImage || variantImages[0]
    const secondImage = v.featuredImage ? variantImages[0] : variantImages[1]

    this.querySelector(".product-card__image .product-card__primary-image img").dataset.src = window.shopUrl + '/cdn/shop/' + firstImage.src
    this.querySelector(".product-card__image .product-card__primary-image img").src = window.shopUrl + '/cdn/shop/' + firstImage.src
    this.querySelector(".product-card__image .product-card__primary-image img").alt = firstImage.alt

    this.querySelector(".product-card__image .product-card__secondary-image img").dataset.src = window.shopUrl + '/cdn/shop/' + secondImage.src
    this.querySelector(".product-card__image .product-card__secondary-image img").src = window.shopUrl + '/cdn/shop/' + secondImage.src
    this.querySelector(".product-card__image .product-card__secondary-image img").alt = secondImage.alt
  }
})

var Accordion = class extends HTMLElement {
  constructor() {
    super()
    this.collapseContent()
  }
  collapseContent() {
    this.content = this.querySelector(".accordion-content")
    this.contentHeight = this.content.offsetHeight
    
    this.style.setProperty('--full-height', `${this.contentHeight}px`)
    
    if(this.contentHeight > 100){
      this.content.classList.add("collapsed")
    } else {
      this.querySelector("button").classList.add("hidden")
    }
  }
}
customElements.define('custom-accordion', Accordion)

var BundleButton = class extends HTMLElement {
  static get observedAttributes() {
    return ['data-active'];
  }

  constructor() {
    super()

    this.bundleBuilder = this.closest("bundle-builder")
  }

  connectedCallback() {
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue !== oldValue) {
      if(name == 'data-active'){
        this.bundleBuilder._setPrice()
      }
    }
  }
}
customElements.define('bundle-button', BundleButton)

var ProductDetailsButton = class extends HTMLElement {
  constructor() {
    super()

    this.bundleBuilder = this.closest("bundle-builder")
    this.productCard = this.closest("product-card")
    this.variantOptions = this.productCard.querySelector("variant-radios") || this.productCard.querySelector("variant-selects")
  }

  connectedCallback() {
    this.addEventListener("click", this._openDetailsModal.bind(this))
  }

  _openDetailsModal(){
    // get variant id
    this.variant = JSON.parse(this.productCard.getAttribute('active-variant'))
    this.swiper = null

    // fetch section and update modal innerHTML
    const fetchLink = `${this.variantOptions.dataset.url}?variant=${this.variant.id}&section_id=product-details-content`

    fetch(fetchLink)
      .then((response) => response.text())
      .then((state) => {
        const html = new DOMParser()
              .parseFromString(state, 'text/html')

        const elementToReplace =
            document.getElementById(`product-details-modal-${this.variantOptions.dataset.sectionId}`)

        elementToReplace.querySelector(".modal-content").innerHTML = html.querySelector(`#product-details-content`).innerHTML

        this.swiper = new Swiper(elementToReplace.querySelector(`.product-details-swiper`), {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          pagination: {
            el: '.swiper-pagination'
          },
          navigation: {
            nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          },
        })
      })

    // open modal
    MicroModal.show('product-details-modal', {
      onClose: modal => {this.swiper.destroy()}
    });
  }
}
customElements.define('product-details-button', ProductDetailsButton)

class ShowPassword extends HTMLElement {
  constructor() {
    super();

    this.passwordField = this.previousElementSibling

    this.addEventListener("click", this.togglePassword.bind(this))
  }

  togglePassword(){
    if (this.passwordField.type === 'password') {
      this.passwordField.type = 'text';
    } else {
      this.passwordField.type = 'password';
    }
  }
}
customElements.define('show-password', ShowPassword)

class BalacizeFlow extends HTMLElement {
  constructor() {
    super();

    // Elements    
    this.openButton = document.querySelectorAll('[data-open-balacize-flow]');
    this.openButton.forEach(b => {
      b.addEventListener('click', this.open.bind(this));
    })

    this.closeIcon = this.querySelector('[data-close-balacize-flow]');
    this.closeIcon.addEventListener('click', this.close.bind(this));

    this.spinner = this.querySelector(".loading-overlay__spinner")

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.customerForm = this.querySelectorAll("form")
    this.customerForm.forEach( f => {
      if( f.getAttribute('action') != '/account/recover') {
        f.addEventListener("submit", this.onSubmitHandler.bind(this))
      }
    })
  }

  open() {
    this.setAttribute('aria-hidden', false);
    this.setAttribute('aria-expanded', true);

    if(this.dataset.customer == 'true' ){
      this.checkUscreenAccess(encodeURIComponent(this.dataset.email)).then((response) => {
        if(response.statusCode === 200) {
          window.location = response.url
        } else {
          this.spinner.classList.add("hidden")
        }
      })
    }
  }

  close(){
    this.setAttribute('aria-hidden', true);
    this.setAttribute('aria-expanded', false);
  }

  onSubmitHandler(evt) {
    evt?.preventDefault()
    this.spinner.classList.remove("hidden")

    const form = evt.target

    const data = new FormData(form)
    const email = form.querySelector("[name='customer[email]']").value

    switch(form.id) {
      case 'balacize-login':
        fetch(`/account/login`, {
          method: 'POST',
          body: data
        })
        .then((response) => {
          if(response.url.includes("/login")) {
            //login failed
            response.text().then((parsedResponse) => {
              const errors =  new DOMParser()
              .parseFromString(parsedResponse, 'text/html')
              .querySelector(".form__message--error").innerHTML;

              form.querySelector(".errors").innerHTML = errors
              this.spinner.classList.add("hidden")
            })
          } else {
            this.checkUscreenAccess(encodeURIComponent(email))
            .then((response) => {
              if(response.statusCode === 200) {
                window.location = response.url
              } else {
                this.updateContent()
                this.spinner.classList.add("hidden")
              }
            })
          }
        })
        
        break;
      case 'balacize-register' :
        fetch(`/account`, {
          method: 'POST',
          body: data
        })
        .then((response) => {
          if(response.url.includes("/register")) {
            //register failed
            response.text().then((parsedResponse) => {
              const errors =  new DOMParser()
              .parseFromString(parsedResponse, 'text/html')
              .querySelector(".form__message--error").innerHTML;

              form.querySelector(".errors").innerHTML = errors
              this.spinner.classList.add("hidden")
            })
          } else {
            this.updateContent()
            this.spinner.classList.add("hidden")
          }
        })
        
        break;
    }
  }

  updateContent() {
    fetch(`?section_id=${this.dataset.id}`)
    .then((response) => response.text())
    .then((parsedResponse) => {
      const balacizeContent = new DOMParser()
      .parseFromString(parsedResponse, 'text/html')
      .querySelector("#balacize-content").innerHTML;

      this.querySelector("#balacize-content").innerHTML = balacizeContent
      this.spinner.classList.add("hidden")
    })
  }

  async checkUscreenAccess(email) {
    const uscreen = await fetch(`https://924eswyxb9.execute-api.us-west-2.amazonaws.com/uscreen?email=${ email }`, {
			method: 'POST',
		}).then(response => { return response.json(); });

		return uscreen;
  }
}

customElements.define('balacize-flow', BalacizeFlow)

// About page swiper
function valuesSwiper() {
  const valuesSwiperEl = document.querySelectorAll('.values-swiper');
  if (!valuesSwiperEl) return;

  const mediaQuery = '(max-width: 768px)';
  const mediaQueryList = window.matchMedia(mediaQuery);

  // Enable swiper
  function enableSwiper() {
    valuesSwiperEl.forEach((el) => {
      const swiper = new Swiper(el, {
        slidesPerView: 1,
        autoHeight: true,
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      })
    })
  }

  // listen for screen size change
  mediaQueryList.addEventListener('change', (event) => {
    if (event.matches) {
      enableSwiper();
    } else {
      document.querySelectorAll('.values-swiper.swiper-initialized').forEach(_s => {
        _s ? _s.swiper.destroy(true, true) : null;
      })
    }
  })

  // On load
  if (window.innerWidth <= 768) {
    enableSwiper();
  }
}

valuesSwiper();

// Image Marquee
function imageMarquee() {
  const imageMarqueeSwiper = document.querySelectorAll('.image-marquee > .slider');
  if (!imageMarqueeSwiper) return;

  const mediaQuery = '(max-width: 768px)';
  const mediaQueryList = window.matchMedia(mediaQuery);

  // Enable swiper
  function enableSwiper() {
    imageMarqueeSwiper.forEach((el) => {
      const swiper = new Swiper(el, {
        slidesPerView: 1,
        loop: true,
        slideClass: 'slide',
        navigation: {
          nextEl: '.image-marquee-button-next',
          prevEl: '.image-marquee-button-prev',
        },
      })
    })
  }

  // listen for screen size change
  mediaQueryList.addEventListener('change', (event) => {
    if (event.matches) {
      enableSwiper();
    } else {
      document.querySelectorAll('.image-marquee > .slider.swiper-initialized').forEach(_s => {
        _s ? _s.swiper.destroy(true, true) : null;
      })
    }
  })

  // On load
  if (window.innerWidth <= 768) {
    enableSwiper();
  }
}

imageMarquee()

// Equipment
function equipmentInfo() {
  const equipmentInfoSwiper = document.querySelectorAll('.equipment-info .swiper');

  if (!equipmentInfoSwiper) return;

  // Enable swiper
  function enableSwiper() {
    equipmentInfoSwiper.forEach((el) => {
      const swiper = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        centerSlides: true,
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: true,
          dragSize: 96,
        },
        navigation: {
          nextEl: '.equipment-info-button-next',
          prevEl: '.equipment-info-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 4,
          }
        }
      })
    })
  }
  enableSwiper()
}

equipmentInfo()

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.headroom').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);

class StickyATC extends SearchForm {
  constructor() {
    super()

    this.mainForm = document.querySelector(`form#product-form-${ this.dataset.formId }`)
    this.mainATC = this.mainForm.querySelector(`#product-form__submit--${ this.dataset.formId}`)

    this.variantButtons = this.querySelectorAll("button[data-value]")
    this.variantButtons.forEach(b => {
      b.addEventListener("click", (event) => {this.updateForm(event)})
    })

    this.addToCart = this.querySelector("button[type='submit']")
    this.addToCart.addEventListener("click", (event) => {this.handleAddToCart(event)})
   
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach( entry => {
          if(entry.boundingClientRect.y < entry.rootBounds?.height)
          this.classList.toggle("show", !entry.isIntersecting)
        })
      },
      {
        rootMargin: `-${(document.querySelector(".headroom").clientHeight)}px`,
        threshold: 0
      }
    )

    if(this.mainForm){
      observer.observe(this.mainATC)
    }
  }

  connectedCallback() {

  }

  handleAddToCart(event) {
    event.preventDefault()

    if(this.mainATC.querySelector("button[name='add']")){
      this.mainForm.dispatchEvent( new Event('submit'))
    } else {
      this.mainForm.scrollIntoView()
    }
  }

  updateForm(event) {
    const target = event.target.tagName == "BUTTON" ? event.target : event.target.closest("button")
    const value = target.dataset.value
 
    const formInput = this.mainForm.querySelector(`input[value="${value}"]`)
    if(!formInput) return

    formInput.checked = true
    const ev = new Event("change")
    formInput.closest('variant-radios') ? formInput.closest('variant-radios').dispatchEvent(ev) : formInput.closest('variant-select').dispatchEvent(ev)
  }
}
customElements.define('sticky-atc', StickyATC);

const membershipAddToCart = (event, fromModal = false) => {
  event?.preventDefault();

  const target = event?.target.tagName == 'BUTTON' ? event.target : event.target.closest("button")

  target.setAttribute('disabled', true);
  target.classList.add('loading');

  const membershipData = document.querySelector("#membership-product")

  if (!membershipData) return

  const body = {
    items: [
      {
      id: membershipData.dataset.id,
      quantity: 1,
      selling_plan: membershipData.dataset.sellingPlan
      }
  ],
    sections: atcGetSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname
  };

  if(membershipData.dataset.freeGift != "" ){
    body.items.push({id: membershipData.dataset.freeGift, quantity: 1 })
  }

  const updateProductForm = []

  if(fromModal == true) {
    const memberModalTrigger = document.querySelector(`[data-micromodal-trigger="membership-benefits-modal"]`) || null
    if( memberModalTrigger ) {
      updateProductForm.push({
        id: 'member-pdp-feature',
        section: memberModalTrigger.dataset.sectionId
      })
      body.sections.push(memberModalTrigger.dataset.sectionId)
    }

    if(memberModalTrigger.parentElement.previousElementSibling.tagName == "PRODUCT-FORM") {
      updateProductForm.push({
        id: 'product-form',
        section: `${ memberModalTrigger.dataset.sectionId }`,
        selector: `${ memberModalTrigger.dataset.productId }-${ memberModalTrigger.dataset.sectionId }`
      })
    } else if(memberModalTrigger.closest("bundle-builder")) {
      updateProductForm.push({
        id: 'bundle-builder',
        section: memberModalTrigger.dataset.sectionId
      })
    }
  }

  addToCart(JSON.stringify(body), true, target, updateProductForm)

  if(fromModal) {
    MicroModal.close("membership-benefits-modal")
  }
}

if(document.querySelector(".rotating-text.swiper")) {
  const rotatingText = new Swiper('.rotating-text.swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: {
      delay: 2000,
    },
    loop: true,
    allowTouchMove: false,
    direction: 'vertical',
    on: {
      afterInit: function() {
  
        const slides = this.el.querySelectorAll('.swiper-slide')
  
        this.el.querySelector(".swiper-wrapper").style.height = `${slides[0].querySelector("div").offsetHeight}px`
  
        slides.forEach(s => {
          s.style.height = `${s.querySelector("div").offsetHeight}px`
        })
      },
      slidesUpdated: function() {
  
        const slides = this.el.querySelectorAll('.swiper-slide')
  
        this.el.querySelector(".swiper-wrapper").style.height = `${slides[0].querySelector("div").offsetHeight}px`
  
        slides.forEach(s => {
          s.style.height = `${s.querySelector("div").offsetHeight}px`
        })
      }
    }
  })
}